var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1962_320)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1962_320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H0V19H19V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1962_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50017 17.4163C13.8724 17.4163 17.4168 13.8719 17.4168 9.49968C17.4168 5.12742 13.8724 1.58301 9.50017 1.58301C5.12791 1.58301 1.5835 5.12742 1.5835 9.49968C1.5835 13.8719 5.12791 17.4163 9.50017 17.4163Z",
    stroke: "#2A2A2B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2502 4.75C10.2502 4.33579 9.91436 4 9.50015 4C9.08594 4 8.75015 4.33579 8.75015 4.75V5.61601C8.32117 5.66592 7.87581 5.78154 7.4932 6.01985C7.00553 6.3236 6.65561 6.80769 6.57725 7.46746C6.51843 7.9626 6.57108 8.41753 6.75709 8.81906C6.94402 9.22256 7.23771 9.51183 7.56061 9.71972C8.15388 10.1017 8.93195 10.2544 9.52124 10.37L9.54854 10.3753L9.59915 10.3852C9.90182 10.4445 10.1679 10.4968 10.4088 10.5619C10.6646 10.631 10.8411 10.7021 10.9579 10.7757C11.0639 10.8424 11.0938 10.8934 11.1074 10.9297C11.1237 10.973 11.1517 11.0922 11.0885 11.3504C11.0576 11.4766 10.9737 11.5974 10.7399 11.7081C10.4896 11.8266 10.1247 11.9002 9.68112 11.9142C8.77584 11.9429 7.83862 11.7191 7.47482 11.5274C7.10837 11.3343 6.65476 11.4748 6.46165 11.8412C6.26853 12.2077 6.40904 12.6613 6.77549 12.8544C7.23592 13.097 7.97377 13.2925 8.75015 13.3747V14.25C8.75015 14.6642 9.08594 15 9.50015 15C9.91436 15 10.2502 14.6642 10.2502 14.25V13.3736C10.6406 13.3248 11.0315 13.2297 11.3817 13.0639C11.9056 12.8159 12.3795 12.385 12.5455 11.7071C12.6571 11.2513 12.6642 10.8081 12.5115 10.4019C12.3561 9.98853 12.069 9.70273 11.7574 9.50646C11.4567 9.31707 11.1152 9.19898 10.8002 9.11384C10.506 9.03434 10.1904 8.97252 9.90246 8.91613L9.83747 8.90339C9.17246 8.77285 8.68752 8.66126 8.37261 8.45851C8.23681 8.37108 8.16195 8.28311 8.11813 8.18853C8.0734 8.09197 8.03309 7.92796 8.06678 7.64438C8.0879 7.46657 8.15895 7.37236 8.28623 7.29307C8.44627 7.19339 8.7116 7.11553 9.08769 7.09125C9.83778 7.04283 10.7456 7.22382 11.3154 7.41547C11.708 7.54752 12.1333 7.3363 12.2654 6.9437C12.3974 6.55109 12.1862 6.12578 11.7936 5.99373C11.3871 5.857 10.8373 5.72099 10.2502 5.64498V4.75Z",
    fill: "#2A2A2B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1962_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarDark);
export default __webpack_public_path__ + "static/media/dollarDark.378f06cf126c46a634b699ed32d4c30c.svg";
export { ForwardRef as ReactComponent };